module.exports = __webpack_public_path__ + "d7f47ab179b488998a6774960cf67608.svg";